import { useI18n } from '@i18n/useI18n';
import { Action, Drop, GraphRow, ImageRow, ImageWrapper, NameCol, Pin_Icon, RItem, TextRow } from './ProfileImageGraph.styled';
import { GridCard } from '@components/GridCards/Common.styled';
import StudentThumbnail from '@components/StudentThumbnail';
import { useStore } from '@store/appStore';
import { useEffect, useState } from 'react';
import moment from 'moment';
import BottomGraph from './BottomGraph';
import Dot_Icon from '@assets/svg/dot-menu.svg';
import Excel_Icon from '@assets/svg/excel.svg';
import { useRouter } from 'next/router';
import { GeneratePdf } from '@utils/pdfTools';
import { ExportStudentExcel } from '@utils/exports/exportStudent';
import db from '@utils/db';
import Tooltip from '@components/Tooltips/Tooltip';
import Alert_On from '@assets/svg/alert-on.svg';
import Alert_Off from '@assets/svg/alert-off.svg';
import PdfIcon from '@assets/svg/pdfColoredBackground.svg';
import { calculatePercentage, ShowabsenceOrAttendance } from '@utils/percentageTools';
import NoteIcon from "@assets/svg/note.svg";
import styled from "@emotion/styled";
import { Devices } from '@styles/tokens';
import { mq } from '@styles/helpers';
import { useDetectClickOutside } from 'react-detect-click-outside';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import CardInfo from '@components/GridCards/CardInfo';

interface IProps {
  username: string,
  firstname: string,
  lastname: string,
  totalAbs: any;
  chartDays: any;
  admin?: boolean;
  schoolView?: boolean;
  counselor?: boolean;
  guardian?: boolean;
  pinnedStudents?: any[];
  notePresent?: boolean;
  noteCount?: number;
  id: string;
  sisId: string;
  pin?: () => any;
}

const NoteCount = styled.div<{ swipeView?: boolean, fullDayView?: boolean }>`
  position: absolute;
  top: 6px;
  right:6px ;
  width: 18px;
  height: 18px!important;
  background:red;
  color:#fff;
  font-size: 12px;
  border-radius:30px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mq(Devices.mobile)} {    
    height:15px;
  }
`;

export const ActivePresence = (props: IProps) => {
  const i18n = useI18n();
  const { settings, systemSettings, callNameSetting, setAlertInfo, filterDate, school, setStudentName, setSelectedStudent, setNote, setNoteUserId } = useStore();
  const [dataPoints, setDataPoints] = useState([]);
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);
  // Tracks the graph's own data readiness separately from `loading` -
  // `loading` can already flip false from the totalAbs effect below before
  // chartDays has arrived, which would otherwise let BottomGraph mount with
  // a still-empty dataPoints array.
  const [graphLoading, setGraphLoading] = useState(true);
  const [action, setAction] = useState(false);
  const { pathname } = useRouter();
  const [downloading, setDownloading] = useState(false)
  let allowNotes = systemSettings.find(t => t.APP_Setting_ID === 9)
  const ClickOutside = () => {
      setAction(false);
    };
  const ref = useDetectClickOutside({ onTriggered: ClickOutside });

  useEffect(() => {
    if (props.chartDays?.length > 0) {
      let temp = [];
      let tempDays = [];
      if (settings.USE_LESSON_BASED_ABSENCE === 'true') {
        temp = props.chartDays.map((d) =>  ShowabsenceOrAttendance(settings.SHOWPRESENCE ,d.lessonspercentage.toFixed(1)));
      } else {
        let maxCount = Math.floor(props.chartDays.length / 7);
        tempDays.push(moment(props.chartDays[0].date).format('D MMM'));
        for (let i = 0; i < props.chartDays.length; i++) {
          temp.push(ShowabsenceOrAttendance(settings.SHOWPRESENCE, props.chartDays[i].secondpercentage.toFixed(1)));
        }
        if (props.chartDays[Math.floor(props.chartDays.length - 1)].date !== props.chartDays[0].date)
          tempDays.push(moment(props.chartDays[props.chartDays.length - 1].date).format('D MMM'));
      }
      setDays(tempDays);
      setDataPoints(temp);
      setLoading(false);
      setGraphLoading(false);
    } else if (props.chartDays?.length === 0) {
      setDays([]);
      setDataPoints([]);
      setLoading(false);
      setGraphLoading(false);
    }
  }, [props.chartDays]);

  useEffect(() => {
    if (props.totalAbs) setLoading(false)
  }, [props.totalAbs])

  const ExportExcel = async (e: any, student: any) => {
    e.stopPropagation()
    if (!downloading) {
      setDownloading(true)
      let tags = (await db.getAllNote_Tags()) ?? []
      for (let index = 0; index < tags.length; index++) {
        const element = tags[index];
        element.name = i18n.t('tag-' + element.name)
      }
      tags.push({ tag_id: 99, name: i18n.t('tag-Late'), html_color: 'FED425', picture: '', late: true })

      let exportText = { filename: (student.firstname + " " + student.lastname).replaceAll(" ", "_") + "_" + (filterDate.from === null ? "01-01-2020" : moment(filterDate.from).format("DD-MM-YYYY")) + "_" + (filterDate.to === null ? moment().format("DD-MM-YYYY") : moment(filterDate.to).format("DD-MM-YYYY")), tabname: (student.firstname + " " + student.lastname).replaceAll(" ", "_"), col1: i18n.t('exportExcel-col1'), col2: i18n.t('exportExcel-col2'), col3: i18n.t('exportExcel-col3'), col4: i18n.t('exportExcel-col4'), col5: i18n.t('exportExcel-col5'), col6: i18n.t('exportExcel-col6'), col7: i18n.t('exportExcel-col7'), col8: i18n.t('exportExcel-col8'), col9: i18n.t('exportExcel-col9'), skole: school, periode: (filterDate.from === null ? "01-01-2020" : moment(filterDate.from).format("DD-MM-YYYY")) + " " + i18n.t('for') + " " + (filterDate.to === null ? moment().format("DD-MM-YYYY") : moment(filterDate.to).format("DD-MM-YYYY")), tags: tags }
      if (filterDate.from !== null) {
        await ExportStudentExcel(student.id, moment(filterDate.from), moment(filterDate.to), exportText)
      } else {
        await ExportStudentExcel(student.id, moment("2020-01-01"), moment(), exportText)
      }
      setTimeout(() => setDownloading(false), 2000)
    }
  }

  const pin = () => {
    props.pin();
  };

  const HandleNote = (e: any) => {
    e.stopPropagation()
    setStudentName(props.firstname + " " + props.lastname)
    setSelectedStudent(props.firstname, props.sisId, false)
    setNoteUserId(props.sisId)
    setNote(true)
  }

  const getButtons = () => {
    let buttons = []
    let showExportButtonsForStudents = systemSettings.find(s => s.APP_Setting_ID === 72)

    if (props.admin && !props.schoolView && !props.counselor && pathname != '/teacherpage' && !props.guardian && pathname != '/counselor') {
      buttons.push(<RItem key={"btn_1"} onClick={() => {pin(); setAction(false)}}      
      >
        <Tooltip
          content={i18n.t(
            props.pinnedStudents?.some((a) => a.username === props.id) ? callNameSetting + '-unpin' : callNameSetting + '-pin',
          )}
          placement={'top-center'}
        >
          <Pin_Icon />
          <span>{props.pinnedStudents?.some((a) => a.username === props.id)?"Unpin":"Pin"}</span>
        </Tooltip>
      </RItem>)
    }

    if (props.counselor) {
      buttons.push(<RItem key={"btn_2"} onClick={() => {setAlertInfo({ open: true, active: alert ? true : false }); setAction(false)}}>
        <Tooltip content={""} placement={'top-center'}>
          {alert ? <Alert_On /> : <Alert_Off />}
          {i18n.t("alert")}
        </Tooltip>
      </RItem>)
    }

    if ((props.admin && !props.guardian) || (props.counselor) || (showExportButtonsForStudents?.value?.toLowerCase() === "true" && !props.guardian)) {
      buttons.push(<Tooltip key={"btn_3"} content={i18n.t(callNameSetting + (settings.SHOWPRESENCE ? '-export' : '-export')) + " " + i18n.t('export-pdf')} placement={'top-center'}>
        <RItem onClick={() => {GeneratePdf(i18n, settings, filterDate, school, props.id, (props.firstname + " " + props.lastname).trim(), ShowabsenceOrAttendance(settings.SHOWPRESENCE, props.totalAbs), settings.SHOWPRESENCE); setAction(false)}}>
          <PdfIcon />
          <span>PDF</span>
        </RItem></Tooltip>)

      buttons.push(<Tooltip key={"btn_4"} content={i18n.t(callNameSetting + (settings.SHOWPRESENCE ? '-export' : '-export')) + " " + i18n.t('export-excel')} placement={'top-center'}><RItem onClick={(e) => {ExportExcel(e, props); setAction(false)}}>
        <Excel_Icon />
        <span>{i18n.t("Rapport")}</span>
      </RItem></Tooltip>)

    }

    if (props.admin && !props.guardian) {
      if (allowNotes.value.toLowerCase() === "true") {
        buttons.push(<RItem key={"btn_5"} onClick={(e) => {HandleNote(e); setAction(false)}}>
          <Tooltip content={i18n.t(props.notePresent ? callNameSetting + "-tooltip-note" : callNameSetting + "-note")} placement={"top-center"} offsetY={-5}>
            <NoteIcon />
            {i18n.t("notes")}
            {props.noteCount > 0 && <NoteCount>{props.noteCount}</NoteCount>}
          </Tooltip>
        </RItem>)
      }
    }

    return buttons
  }
  // console.log("firstname: " + props.firstname)
  // console.log("lastname: " + props.lastname)
  return (
    <GridCard col={1} overflowHidden={true} mobileHeight={true} style={{ display: "flex", flexDirection: "column" }}>
      {props.guardian?<CardInfo padding={true} text='info-text-graph' />:null}
      {loading?<RainbowLoader />:
      <>
      {!props.guardian?<ImageRow>
        <ImageWrapper>
          <StudentThumbnail bigFont={"26px"} font={"7vw"} name={props.firstname + " " + props.lastname} src={props.username} />
        </ImageWrapper>
        <NameCol>
          <span>{props.firstname}</span>
          <span>{props.lastname}</span>
        </NameCol>
        {getButtons()?.length > 0?
        <Action ref={ref} >
          <Dot_Icon onClick={() => setAction(!action)} />
          <Drop show={action}>
            {getButtons()}
          </Drop>
        </Action>
        :null}
      </ImageRow>:null}
      <TextRow>
        <span>{i18n.t(props.admin?(settings.SHOWPRESENCE?'attendance':'absence'):(settings.SHOWPRESENCE?'your-attendance':'your-absence'))}</span>
        <p>{isNaN(props.totalAbs) ? "-" : ShowabsenceOrAttendance(settings.SHOWPRESENCE ,props.totalAbs) + "%"}</p>
      </TextRow>
      <GraphRow>
        {graphLoading ? <RainbowLoader /> : <BottomGraph dataPoints={dataPoints} chartData={props.chartDays} />}
      </GraphRow>
      </>}
    </GridCard>
  );
};

export default ActivePresence;
